__turbopack_context__.v({
  "blocksBackgroundColor": "image-module-scss-module__KyqUWW__blocksBackgroundColor",
  "blocksFontColor": "image-module-scss-module__KyqUWW__blocksFontColor",
  "container": "image-module-scss-module__KyqUWW__container",
  "cover": "image-module-scss-module__KyqUWW__cover" + " " + "image-module-scss-module__KyqUWW__image",
  "coverWelcomePage": "image-module-scss-module__KyqUWW__coverWelcomePage",
  "image": "image-module-scss-module__KyqUWW__image",
  "repeatX": "image-module-scss-module__KyqUWW__repeatX" + " " + "image-module-scss-module__KyqUWW__image",
  "repeatY": "image-module-scss-module__KyqUWW__repeatY" + " " + "image-module-scss-module__KyqUWW__image",
  "secondaryNavBackgroundColor": "image-module-scss-module__KyqUWW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "image-module-scss-module__KyqUWW__themeBackgroundColor",
  "themeFontColor": "image-module-scss-module__KyqUWW__themeFontColor",
});
